export const KEYS = {
    enableAdaptiveUi: 'enableAdaptiveUi',
    enableCompactView: 'enableCompactView',
    defaultTheme: 'default_theme',
    user: 'user',
    outing: 'outing',
    globalOuting: 'globalOuting',
    globalOutingIteration: 'globalOutingIteration',
    stripeTerminalReader: 'stripeMainReader'
  };
